import { Box } from "@mui/material";
import { KeyDriveBodyMax } from "../../../../components/KeydriveComponents/Fonts/Body/KeyDriveBodyMax";
import { KeyDriveBodyMin } from "../../../../components/KeydriveComponents/Fonts/Body/KeyDriveBodyMin";
import { KeyDriveCaption } from "../../../../components/KeydriveComponents/Fonts/Captions/KeyDriveCaption";
import { KeydrivePlan } from "../../../../model/UserModel";
import { useTranslation } from "react-i18next";
import { formatCurrency } from "../../../../utils/FormatCurrency";

interface IAccountPlanCard {
    price: string;
    totalUsers: string;
    planStatus: string;
    contractStorage: string;
    plan: KeydrivePlan;
    usersUsed: number;
}

export default function AccountPlanCard({
    contractStorage,
    planStatus,
    price,
    totalUsers,
    plan,
    usersUsed
}: IAccountPlanCard) {

    const { t } = useTranslation();

    function getKeydrivePlan(): string 
    {
        switch(plan) 
        {
            case KeydrivePlan.PERSONAL:
                return "Personal";

            case KeydrivePlan.FREE:
                return t("AccountAndSubscription.AccountPlan.Free");

            case KeydrivePlan.ESSENCIAL:
                return "Essencial";
            
            case KeydrivePlan.PROFISSIONAL:
                return "Profissional";
            
            case KeydrivePlan.SCALE:
                return "Scale";
            
            default:
                return t("AccountAndSubscription.AccountPlan.Free");
        }
    }

    console.log(totalUsers)

    return (
        <>
            <Box sx={{width: "100%"}}>
                <KeyDriveBodyMax 
                    color="#000000"
                    needBold
                    needEllipses={false}
                    text={t("AccountAndSubscription.Plan")}
                />
                <Box
                    minWidth="450px"
                    width="100%"
                    height="110px"
                    sx={{
                        border: "1px solid #EAEAEA",
                        borderRadius: "4px"
                    }}
                    marginTop="12px"
                >
                    <Box
                        display="flex"
                        justifyContent="space-between"
                        padding="10px"
                    >
                        <Box>
                            <KeyDriveBodyMax 
                                color="#969696"
                                needBold={false}
                                needEllipses={false}
                                text={t("AccountAndSubscription.Category")}
                            />
                            <KeyDriveBodyMin 
                                color="#000000"
                                needBold
                                needEllipses={false}
                                text={planStatus}
                            />
                        </Box>
                        <Box>
                            <KeyDriveBodyMax 
                                color="#969696"
                                needBold={false}
                                needEllipses={false}
                                text={t("AccountAndSubscription.Plan")}
                            />
                            <KeyDriveBodyMin 
                                color="#000000"
                                needBold
                                needEllipses={false}
                                text={getKeydrivePlan()}
                            />
                        </Box>
                        <Box>
                            <KeyDriveBodyMax 
                                color="#969696"
                                needBold={false}
                                needEllipses={false}
                                text={t("AccountAndSubscription.Users")}
                            />
                            <KeyDriveBodyMin 
                                color="#000000"
                                needBold
                                needEllipses={false}
                                text={`${usersUsed?.toString()} / ${totalUsers}`}
                            />
                        </Box>
                        <Box>
                            <KeyDriveBodyMax 
                                color="#969696"
                                needBold={false}
                                needEllipses={false}
                                text={t("AccountAndSubscription.Storage")}
                            />
                            <KeyDriveBodyMin 
                                color="#000000"
                                needBold
                                needEllipses={false}
                                text={contractStorage}
                            />
                        </Box>
                        <Box>
                            <KeyDriveBodyMax 
                                color="#969696"
                                needBold={false}
                                needEllipses={false}
                                text={t("AccountAndSubscription.ContractValue")}
                            />
                            <KeyDriveBodyMin 
                                color="#000000"
                                needBold
                                needEllipses={false}
                                text={formatCurrency(Number.parseFloat(price))}
                            />
                        </Box>
                    </Box>
                    <Box
                        width="100%"
                        height="42.5px"
                        sx={{
                            backgroundColor: "#EAEAEA"
                        }}
                        display="flex"
                        justifyContent="center"
                        alignItems="center"
                    >
                        <KeyDriveCaption 
                            color="#000000"
                            needBold={false}
                            needEllipses={false}
                            text={t("AccountAndSubscription.SwitchPlansEveryMoment")}
                        />
                    </Box>
                </Box>
            </Box>
        </>
    )
}